import { render, staticRenderFns } from "./image2.vue?vue&type=template&id=9b9f9c94&scoped=true"
import script from "./image2.vue?vue&type=script&lang=js"
export * from "./image2.vue?vue&type=script&lang=js"
import style0 from "./image2.vue?vue&type=style&index=0&id=9b9f9c94&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9b9f9c94",
  null
  
)

export default component.exports